import { Controller } from "@hotwired/stimulus"
import { get, post } from "@rails/request.js"
import Modal from "bootstrap/js/dist/modal"

export default class extends Controller {
  static targets = ["modal", "formContainer"]

  async open(event) {
    const tournamentId = event.currentTarget.dataset.tournamentId
    if (!tournamentId) return

    const response = await get(`/backend/tournaments/${tournamentId}/team_registrations/new`, { responseKind: "html" })
    this.formContainerTarget.innerHTML = await response.html
    Modal.getOrCreateInstance(this.modalTarget).show()
  }

  async submit(event) {
    event.preventDefault()

    const response = await post(event.target.action, { body: new FormData(event.target), responseKind: "json" })
    const data = await response.json

    if (data.success) {
      // Wait for the modal's hide transition to finish before reloading, so the
      // backdrop/body scroll-lock get cleaned up rather than left mid-transition.
      this.modalTarget.addEventListener("hidden.bs.modal", () => window.location.reload(), { once: true })
      Modal.getOrCreateInstance(this.modalTarget).hide()
    } else {
      this.formContainerTarget.innerHTML = data.partials["team-registration-form"]
    }
  }
}
